module.exports = __webpack_public_path__ + "img/belt_6.a94c0181.png";